import { lazy } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import { LoginPage } from "@/features/auth/login-page";
import { RequireAuth } from "@/features/auth/require-auth";
import { AppShell } from "@/shared/layout/app-shell";

const AnalyticsPage = lazy(() => import("@/features/analytics/analytics-page").then(module => ({ default: module.AnalyticsPage })));
const UsersPage = lazy(() => import("@/features/users/users-page").then(module => ({ default: module.UsersPage })));
const UsagePage = lazy(() => import("@/features/usage/usage-page").then(module => ({ default: module.UsagePage })));
const UsageAnalyticsPage = lazy(() => import("@/features/usage/usage-analytics-page").then(module => ({ default: module.UsageAnalyticsPage })));
const BillingPage = lazy(() => import("@/features/billing/billing-page").then(module => ({ default: module.BillingPage })));
const AlphaHoursPage = lazy(() => import("@/features/billing/alpha-hours-page").then(module => ({ default: module.AlphaHoursPage })));
const PrepaidCatalogPage = lazy(() => import("@/features/billing/prepaid-catalog-page").then(module => ({ default: module.PrepaidCatalogPage })));
const BeConfigPage = lazy(() => import("@/features/config/be-config-page").then(module => ({ default: module.BeConfigPage })));
const TvConfigPage = lazy(() => import("@/features/tv/tv-config-page").then(module => ({ default: module.TvConfigPage })));
const TvMetricsPage = lazy(() => import("@/features/tv/tv-metrics-page").then(module => ({ default: module.TvMetricsPage })));
const TvPayoutsPage = lazy(() => import("@/features/tv/tv-payouts-page").then(module => ({ default: module.TvPayoutsPage })));
const TvUsersPage = lazy(() => import("@/features/tv/tv-users-page").then(module => ({ default: module.TvUsersPage })));
const PingysTvLiveBannersPage = lazy(() => import("@/features/tv/pingys-tv-live-banners-page").then(module => ({ default: module.PingysTvLiveBannersPage })));
const BannersPage = lazy(() => import("@/features/banners/banners-page").then(module => ({ default: module.BannersPage })));
const ReferralCampaignsPage = lazy(() => import("@/features/referrals/referral-campaigns-page").then(module => ({ default: module.ReferralCampaignsPage })));
const TwitchFollowersPage = lazy(() => import("@/features/followers/twitch-followers-page").then(module => ({ default: module.TwitchFollowersPage })));
const PartnershipsPage = lazy(() => import("@/features/partnerships/partnerships-page").then(module => ({ default: module.PartnershipsPage })));
const VoicesPage = lazy(() => import("@/features/voices/voices-page").then(module => ({ default: module.VoicesPage })));
const CharactersPage = lazy(() => import("@/features/characters/characters-page").then(module => ({ default: module.CharactersPage })));

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <AnalyticsPage dashboard /> },
      { path: "analytics", element: <AnalyticsPage /> },
      { path: "analytics/legacy", element: <UsageAnalyticsPage /> },
      { path: "users", element: <UsersPage /> },
      { path: "usage", element: <UsagePage /> },
      { path: "alpha-hours", element: <AlphaHoursPage /> },
      { path: "billing", element: <BillingPage /> },
      { path: "be/config", element: <BeConfigPage /> },
      { path: "catalog", element: <PrepaidCatalogPage /> },
      { path: "subscriptions", element: <Navigate to="/catalog" replace /> },
      { path: "tv/config", element: <TvConfigPage /> },
      { path: "tv/users", element: <TvUsersPage /> },
      { path: "tv/metrics", element: <TvMetricsPage /> },
      { path: "tv/payouts", element: <TvPayoutsPage /> },
      { path: "tv/live-banners", element: <PingysTvLiveBannersPage /> },
      { path: "referrals", element: <ReferralCampaignsPage /> },
      { path: "partnerships", element: <PartnershipsPage /> },
      { path: "twitch/followers", element: <TwitchFollowersPage /> },
      { path: "banners", element: <BannersPage /> },
      { path: "voices", element: <VoicesPage /> },
      { path: "characters", element: <CharactersPage /> },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);
